const getConditionStatusColors = (status) => {
  switch (status) {
    case 'incomplete':
      return '#4b5d6b'
    case 'completed':
      return '#4ca392'
    default:
      return ''
  }
}

export { getConditionStatusColors }
